createPortalModel